/** Имена статусов заявок в API dispatcher */
export const QUEST_STATUS = {
  NEW: 'New',
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const QUEST_STATUS_BY_TAB_INDEX = [
  QUEST_STATUS.NEW,
  QUEST_STATUS.ASSIGNED,
  QUEST_STATUS.IN_PROGRESS,
  QUEST_STATUS.COMPLETED,
  QUEST_STATUS.CANCELLED,
];

const STATUS_INDEX_BY_NAME = {
  [QUEST_STATUS.NEW]: 0,
  [QUEST_STATUS.ASSIGNED]: 1,
  [QUEST_STATUS.IN_PROGRESS]: 2,
  [QUEST_STATUS.COMPLETED]: 3,
  [QUEST_STATUS.CANCELLED]: 4,
};

const STATUS_NAME_ALIASES = {
  new: QUEST_STATUS.NEW,
  новая: QUEST_STATUS.NEW,
  новые: QUEST_STATUS.NEW,
  assigned: QUEST_STATUS.ASSIGNED,
  назначена: QUEST_STATUS.ASSIGNED,
  назначены: QUEST_STATUS.ASSIGNED,
  inprogress: QUEST_STATUS.IN_PROGRESS,
  вработе: QUEST_STATUS.IN_PROGRESS,
  completed: QUEST_STATUS.COMPLETED,
  завершена: QUEST_STATUS.COMPLETED,
  завершены: QUEST_STATUS.COMPLETED,
  cancelled: QUEST_STATUS.CANCELLED,
  canceled: QUEST_STATUS.CANCELLED,
  отменена: QUEST_STATUS.CANCELLED,
  отменены: QUEST_STATUS.CANCELLED,
};

const STATUS_LABELS_RU = {
  [QUEST_STATUS.NEW]: 'Новая',
  [QUEST_STATUS.ASSIGNED]: 'Назначена',
  [QUEST_STATUS.IN_PROGRESS]: 'В работе',
  [QUEST_STATUS.COMPLETED]: 'Завершена',
  [QUEST_STATUS.CANCELLED]: 'Отменена',
};

const STATUS_CHIP_COLORS = {
  [QUEST_STATUS.NEW]: 'info',
  [QUEST_STATUS.ASSIGNED]: 'warning',
  [QUEST_STATUS.IN_PROGRESS]: 'secondary',
  [QUEST_STATUS.COMPLETED]: 'success',
  [QUEST_STATUS.CANCELLED]: 'error',
};

/**
 * Нормализует статус заявки к строковому имени API (New, Assigned, …).
 * Поддерживает legacy: число 0–4, строка "0"–"4".
 */
export const normalizeQuestStatus = (questOrStatus) => {
  const raw =
    typeof questOrStatus === 'object'
      ? questOrStatus?.status ??
        questOrStatus?.statusId ??
        questOrStatus?.Status ??
        questOrStatus?.StatusId ??
        questOrStatus?.statusName ??
        questOrStatus?.StatusName ??
        questOrStatus?.questStatusName ??
        questOrStatus?.QuestStatusName
      : questOrStatus;

  if (raw == null || raw === '') {
    return QUEST_STATUS.NEW;
  }

  if (typeof raw === 'object') {
    return normalizeQuestStatus(
      raw.status ??
      raw.statusId ??
      raw.id ??
      raw.Id ??
      raw.code ??
      raw.Code ??
      raw.name ??
      raw.Name
    );
  }

  if (typeof raw === 'string' && STATUS_INDEX_BY_NAME[raw] !== undefined) {
    return raw;
  }

  const num = Number(raw);
  if (!Number.isNaN(num) && num >= 0 && num <= 4) {
    return QUEST_STATUS_BY_TAB_INDEX[num];
  }

  const normalizedName = String(raw).trim().toLowerCase().replace(/[\s_-]+/g, '');
  return STATUS_NAME_ALIASES[normalizedName] || String(raw);
};

/** Индекс вкладки 0–4 */
export const getQuestStatusIndex = (questOrStatus) => {
  const name = normalizeQuestStatus(questOrStatus);
  return STATUS_INDEX_BY_NAME[name] ?? 0;
};

export const getStatusLabel = (questOrStatus) => {
  const name = normalizeQuestStatus(questOrStatus);
  return STATUS_LABELS_RU[name] || 'Неизвестный';
};

export const getStatusChipConfig = (questOrStatus) => ({
  label: getStatusLabel(questOrStatus),
  color: STATUS_CHIP_COLORS[normalizeQuestStatus(questOrStatus)] || 'default',
});

/** Код статуса для query-параметра Statuses (0–4) */
export const tabIndexToStatusCode = (tabIndex) => tabIndex;

export const questStatusToTabIndex = (questOrStatus) => getQuestStatusIndex(questOrStatus);
